import { render, staticRenderFns } from "./Calendars.vue?vue&type=template&id=cffffd36&scoped=true"
import script from "./Calendars.vue?vue&type=script&lang=js"
export * from "./Calendars.vue?vue&type=script&lang=js"
import style0 from "./Calendars.vue?vue&type=style&index=0&id=cffffd36&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cffffd36",
  null
  
)

export default component.exports